import variationNotes from './variationNotes'
import emailPreferences from './email-preferences.js';
import memberWelcome from './member-welcome';
import socialSharing from './social-sharing.js';
import variation from './variation.js'
import clipPlatforms from './clipPlatforms.js'
import publicVideo from './public-video'
import community from './community.js';
import scoreboard from './scoreboard.js';
import contentDetails from './content-details.js';
import proofing from './proofing.js';
import shared from './shared.js';
import users from './users.js';
import errors from './errors.js';
import workflowFeedback from './workflow-feedback.js';
import folders from './folders.js';
import operationsPortal from './operations-portal.js';
import recording from './recording.js';
import groups from './groups.js';
import media from './media.js';
import companies from './companies.js';
import optionsTraining from './options-training.js';
import request from './request.js';
import uploader from './uploader.js';
import organization from './organization.js';
import room from './room.js';
import writeup from './writeup.js';
import leads from './leads.js';
import simpleLogin from './simple-login.js';
import microlearning from './microlearning.js';
import editAssignments from './edit-assignments.js';
import covert from './covert.js';
import editingContinuity from './editing-continuity.js';
import contentTracker from './content-tracker.js';
import hostWorkspace from './host-workspace.js';
import notifications from './notifications.js';
import onsiteCredits from './onsite-credits.js';
import onsiteCancellation from './onsite-cancellation.js';
import brandChecks from './brand-checks.js';
import approvalQueue from './approval-queue.js';
import activation from './activation';
import activationLegacy from './activation-legacy';

export default {
    variationNotes,
    variation,
    clipPlatforms,
    emailPreferences,
  memberWelcome,
    activation,
    activationLegacy,
    socialSharing,
    publicVideo,
    scoreboard,
    editingContinuity,
    brandChecks,
    approvalQueue,
    search: {
        selectLoaded: 'Select loaded media with checkboxes ({count})',
        selectionScope: '{selected} selected across filters. The count includes only loaded Videos, Uploads, Podcasts and Recording Rooms with checkboxes. Social Sharing, Folders and other result types are not selectable. Scroll to load more selectable media, then select again.',
    },
    community,
    contentDetails,
    proofing,
    shared,
    users,
    errors,
    workflowFeedback,
    folders,
    operationsPortal,
    recording,
    groups,
    media,
    companies,
    optionsTraining,
    request,
    uploader,
    organization,
    room,
    writeup,
    leads,
    simpleLogin,
    microlearning,
    editAssignments,
    covert,
    contentTracker,
    hostWorkspace,
    notifications,
    onsiteCredits,
    onsiteCancellation,
}
